<template lang="pug">
  v-row(justify='center', align='center')
    v-col.text-center
      h1 Mapas temáticos
      br
      br
      h3 Selecciona un tipo de mapa
      div
        v-container
          v-row.align-center.justify-center
            // (cols="2", xs="6", md="4", lg="3")
            //- .col-xs-6.col-md-6.col-lg-3.col-xl-2
            v-col(cols="12", sm="6", md="4", justify='center', align='center', v-for="obj in categories", v-if="maps[obj].length > 0" :key="obj")
              v-hover
                v-card.card-galelly-object.v-card--raised.v-sheet.theme--light(supportingtext='true', image='true', style='width: 100%;  cursor: pointer;', @click="selectCategory(obj)", slot-scope="{ hover }", :class="`elevation-${hover ? 12 : 2}`")
                  //- .d-flex.align-center.justify-center.v-sheet.theme--light.grey.lighten-3(style='height: 200px;')
                    i.v-icon.notranslate.mdi.mdi-image.theme--light(aria-hidden='true', style='font-size: 64px;')
                  .v-card__title.text-center(justify='center', align='center')
                    v-row
                      v-col.word-break-all(v-if="mapTypes && mapTypes[obj]", justify='center', align='center') {{mapTypes[obj].label}}
                      v-col(v-if="!mapTypes || !mapTypes[obj]", justify='center', align='center') Sin clasificar
                  // 
                  .v-card__text(v-if="mapTypes && mapTypes[obj]")
                    //- v-img.grey.darken-4(:src="require(mapTypes[obj].imgPath)")
                    v-img.grey.darken-4(:src="mapTypes[obj].img")
                    div.text-justify {{mapTypes[obj].description}}
                    div Disponibles: {{maps[obj].length}}
                  .v-card__text(v-if="!mapTypes || !mapTypes[obj]")
                    v-img.grey.darken-4(:src='maps[obj][0].url')
                    div Disponibles: {{maps[obj].length}}
      //- div {{maps}}
      slider(v-if="mapsAvailable.length > 0", :categorySelected="categorySelected" :maps="mapsAvailable", @cancel="cancel")
</template>

<script>
// @ is an alias to /src
import Slider from '@/components/Slider.vue'

import mapService from '@/services/map'

export default {
  name: 'Gallery',
  components: { Slider },
  data() {
    return {
      maps: {},
      mapsAvailable: [],
      categories: [],
      categorySelected: '',
      mapTypes: []
    }
  },
  methods: {
    cancel() {
      this.mapsAvailable = []
      this.categorySelected = ''
    },
    selectCategory(category) {
      this.mapsAvailable = this.maps[category]
      this.categorySelected = category
    }
  },
  created() {
    this.mapTypes['mundial-1'] = {
      id: 'mundial-1',
      label: 'COVID-19 a nivel mundial-1',
      description:
        'Este mapa muestra la distribución mundial de los casos confirmados por COVID-19 y se pueden observar las regiones del mundo que han presentado mayor número de casos. Información disponible en varias fechas.',
      img: require('../assets/mundial-1-tm.png')
    }

    this.mapTypes['mundial-2'] = {
      id: 'mundial-2',
      label: 'COVID-19 a nivel mundial-2',
      description:
        'En este mapa se muestra la distribución de los casos confirmados por COVID-19 y también se puede observar la cantidad de muertes y casos recuperados en cada país. Información disponible en varias fechas.',
      img: require('../assets/mundial-2-tm.png')
    }

    this.mapTypes['procedencia'] = {
      id: 'procedencia',
      label: 'Procedencia de contagios en México por COVID-19',
      description:
        'Este mapa muestra el número de casos confirmados acumulados por COVID-19 y la procedencia donde posiblemente se contagiaron. Información disponible en varias fechas.',
      img: require('../assets/procedencia-tm.png')
    }

    this.mapTypes['genero'] = {
      id: 'genero',
      label: 'COVID-19 por género en México',
      description:
        'Este mapa muestra la distribución por estado de los casos confirmados acumulados haciendo énfasis en la situación de género. Información disponible en varias fechas.',
      img: require('../assets/genero-tm.png')
    }

    this.mapTypes['grupos-edad'] = {
      id: 'grupos-edad',
      label: 'COVID-19 de acuerdo con la población total y grupos de edad en México',
      description:
        'Este mapa expone el total de casos confirmados acumulados por estado, la población total (2015) y los diferentes grupos de edad. Con esta información se puede identificar cuáles son los estados que tienen más infectados y los grupos de edad más vulnerables. Información disponible en varias fechas.',
      img: require('../assets/grupos-edad-tm.jpg')
    }

    this.mapTypes['marginacion'] = {
      id: 'marginacion',
      label: 'COVID-19 según grado de marginación en México',
      description:
        'Este mapa muestra el número total de casos positivos acumulados a nivel estatal y el grado de marginación, con lo que se pretende analizar si existe una correlación entre estas dos variables. Información disponible en varias fechas.',
      img: require('../assets/marginacion-tm.jpg')
    }

    this.mapTypes['hacinamiento'] = {
      id: 'hacinamiento',
      label: 'COVID-19 según porcentaje de hacinamiento',
      description:
        'La intención de este mapa es mostrar el número total de casos confirmados acumulados y el porcentaje de viviendas con hacinamiento a nivel estatal para analizar si en los estados con mayor número de viviendas hacinadas, puede existir un mayor riesgo de contagio comunitario. Información disponible en varias fechas.',
      img: require('../assets/hacinamiento-tm.jpg')
    }

    this.mapTypes['hospitales'] = {
      id: 'hospitales',
      label: 'Hospitales COVID-19 en CDMX y EDOMEX',
      description:
        'Esta serie de mapas, expone la distribución de los hospitales que atienden a pacientes con la enfermedad COVID-19 en la Ciudad de México (CDMX) y el Estado de México (EDOMEX). También podemos observar el número de casos activos por municipio y saber dónde se encuentran los municipios con más contagios. Información disponible en varias fechas.',
      img: require('../assets/hospitales-tm.png')
    }

    this.mapTypes['laboratorios'] = {
      id: 'laboratorios',
      label: 'Laboratorios COVID-19',
      description:
        'Este mapa muestra la distribución territorial de los laboratorios que realizan la prueba de COVID-19 en México, ya sea de laboratorios pertenecientes a instituciones públicas como el IMSS, hospitales estatales o de laboratorios privados. También muestra el número de médicos en instituciones públicas por cada mil habitantes a nivel estatal.',
      img: require('../assets/laboratorios-tm.png')
    }
  },
  mounted() {
    mapService.list().then(res => {
      this.maps = res.data
      let tempArray = Object.keys(res.data)
      for (let i = 0; i < tempArray.length - 1; i++) {
        for (let j = i; j < tempArray.length - 1; j++) {
          if (tempArray[j] > tempArray[j + 1]) {
            let tempObj = tempArray[j]
            tempArray[j] = tempArray[j + 1]
            tempArray[j + 1] = tempObj
          }
        }
      }
      this.categories = tempArray
    })
  }
}
</script>

<style>
.card-galelly-object {
  height: 620px !important;
}
</style>
